import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonUnassign = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9C14 10.5202 13.3215 11.882 12.2509 12.7991C14.4798 13.97 16 16.3075 16 19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19C14 16.2386 11.7614 14 9 14C6.23858 14 4 16.2386 4 19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19C2 16.3075 3.52021 13.97 5.74913 12.7991C4.67847 11.882 4 10.5202 4 9ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.7071 4.87868C20.0976 4.48815 20.7308 4.48815 21.1213 4.87868C21.5118 5.2692 21.5118 5.90237 21.1213 6.29289L20.4142 7L21.1213 7.70711C21.5118 8.09763 21.5118 8.7308 21.1213 9.12132C20.7308 9.51184 20.0976 9.51184 19.7071 9.12132L19 8.41422L18.2929 9.12132C17.9024 9.51184 17.2692 9.51184 16.8787 9.12132C16.4882 8.73079 16.4882 8.09763 16.8787 7.7071L17.5858 7L16.8787 6.29289C16.4882 5.90237 16.4882 5.2692 16.8787 4.87868C17.2692 4.48816 17.9024 4.48816 18.2929 4.87868L19 5.58579L19.7071 4.87868Z",
		fill: "currentColor"
	})]
});
export default SvgPersonUnassign;
